/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ vat: NonNullable<unknown> }} Ticketseventvatusualis4Inputs */

const en_ticketseventvatusualis4 = /** @type {(inputs: Ticketseventvatusualis4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`As usual: ${i?.vat}`)
};

const de_ticketseventvatusualis4 = /** @type {(inputs: Ticketseventvatusualis4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wie sonst auch: ${i?.vat}`)
};

/**
* | output |
* | --- |
* | "As usual: {vat}" |
*
* @param {Ticketseventvatusualis4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketseventvatusualis4 = /** @type {((inputs: Ticketseventvatusualis4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketseventvatusualis4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketseventvatusualis4(inputs)
	return de_ticketseventvatusualis4(inputs)
});
export { ticketseventvatusualis4 as "ticketsEventVatUsualIs" }